<template>
  <div>
    <!-- <DialogCheckbox
      v-model="show"
      :data="headers"
      value-key="show"
      name-key="text"
      title="Kolonner som skal eksporteres"
      cancelButtonName="Lukk"
    /> -->
  </div>
</template>

<script>
// import DialogCheckbox from "@/components/Shared/dialog/DialogCheckbox";
export default {
  props: {
    value: {
      required: true,
    },
    headers: {},
    items: {},
    color: {
      default: "success",
    },
    exportName: {
      default: null,
    },
  },
  data() {
    return {
      data: { columns: [], footer: [], rows: [] },
      showDialog: false,
    };
  },
  computed: {
    show: {
      get: function () {
        return this.value;
      },
      set: function (value) {
        this.$emit("input", value);
      },
    },
  },
  components: {
    // DialogCheckbox,
  },
};
</script>
